import React from "react";
import styled from "styled-components/macro";
import { Button, Colors } from "../../odc-ui";
import { Frame } from "@bitesite/react-figstrap";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";

const PrintBannerContainer = styled.div`
  padding: 10px 0;
  background-color: ${Colors.lightGrey200};
  margin-bottom: 10px;
  @media print {
    display: none;
  }
`;

const PrintBannerInnerContainer = styled(Frame)`
  margin: 0 auto;
  width: 100%;
  max-width: 1128px;
`;

const PrintBanner = ({ readyToPrint }) => {
  return (
    <PrintBannerContainer>
      <PrintBannerInnerContainer justifyContent="flex-end">
        <Button
          type="dark"
          onClick={(e) => {
            e.preventDefault();
            window.print();
          }}
          disabled={!readyToPrint}
          gap={5}
        >
          {readyToPrint ? (
            <>
              <Icon icon="material-symbols:print" /> Print
            </>
          ) : (
            "Please wait..."
          )}
        </Button>
      </PrintBannerInnerContainer>
    </PrintBannerContainer>
  );
};

PrintBanner.propTypes = {
  readyToPrint: PropTypes.bool,
};

export default PrintBanner;
